import type React from 'react';
import { createPortal } from 'react-dom';

import { useToolbarPortal } from '@atlaskit/editor-core';

export const ToolbarPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { isActive } = useToolbarPortal() ?? {};

	// When inactive, don't render the toolbar at all
	if (!isActive) {
		return null;
	}

	const element = document.querySelector('.ak-editor-toolbar-portal');

	if (!element) {
		return null;
	}

	return createPortal(children, element);
};
